import { render, staticRenderFns } from "./assignmentScore.vue?vue&type=template&id=205fe5e0&scoped=true&"
import script from "./assignmentScore.vue?vue&type=script&lang=js&"
export * from "./assignmentScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fe5e0",
  null
  
)

export default component.exports